import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import _ from 'lodash';
import styles from './List.css';

class Row extends React.Component {
  render() {
    const { role, openRightColumn } = this.props;
    const sortedEmployeesByName = _.sortBy(role.employees, [
      'first_name',
      'last_name',
    ]);
    const popoverEmployee = (
      <Popover id="popover-employee-access" title="Assigned Employee">
        <ul>
          {sortedEmployeesByName.map(employee => {
            return (
              <li key={employee.id} className={`${styles.ellipsis}`}>
                {' '}
                • {`${employee.first_name} ${employee.last_name}`}{' '}
              </li>
            );
          })}
        </ul>
      </Popover>
    );

    return (
      <tr
        className={`${this.props.isSelected ? styles.selected : ''}`}
        onClick={this._onClickRow}
      >
        <td
          className={`${openRightColumn ? 'col-md-3' : 'col-md-4'} ${
            styles.roleName
          }`}
        >
          {role.name}
        </td>
        <td className={`${openRightColumn ? 'col-md-3' : 'col-md-4'}`}>
          {role.employees.length > 1 && (
            <OverlayTrigger
              trigger={['hover', 'focus']}
              overlay={popoverEmployee}
            >
              <div className={`${styles['employee-label']}`}>
                {role.employees.length} Employees
              </div>
            </OverlayTrigger>
          )}
          {role.employees.length === 1 && (
            <div>
              {`${role.employees[0].first_name} ${role.employees[0].last_name}`}
            </div>
          )}
        </td>
        <td className={`${openRightColumn ? 'col-md-6' : 'col-md-4'}`}>
          {this._hasPermissions() && this._getPrivilegesView()}
        </td>
      </tr>
    );
  }

  _hasPermissions = () => {
    return Boolean(
      this.props.role.permissions && this.props.role.permissions.length
    );
  };

  _getMenuPermissionByAccess = () => {
    const { role } = this.props;
    const permissionsOf = _.groupBy(role.permissions, 'access');
    const appPermissionMenuList = _.uniqBy(permissionsOf.App, 'sub_menu');
    const backOfficePermissionMenuList = _.uniqBy(
      permissionsOf['Back-office'],
      'menu'
    );

    return {
      app: appPermissionMenuList,
      backOffice: backOfficePermissionMenuList,
    };
  };

  _getPrivilegesView = () => {
    // TODO TO BE IMPROVED LOGIC BELOW
    const { role, userPermissions } = this.props;
    const permissionOf = this._getMenuPermissionByAccess();
    const roleTotalPermission =
      permissionOf.app.length + permissionOf.backOffice.length;
    let accessGroupTypeMessage;
    let privilegesMessage;
    const permissionsOf = this._getMenuPermissionByAccess();
    const popoverAccess = (
      <Popover id="popover-employee-list" title="Employee Access">
        {permissionsOf.app !== null && permissionsOf.app.length > 0 && (
          <div className={`${styles['list-heading']}`}>APP</div>
        )}
        <ul>
          {_.sortBy(permissionsOf.app, 'priority_rank').map(permission => (
            <li key={permission.id}>• {permission.sub_menu_name}</li>
          ))}
        </ul>
        {permissionsOf.backOffice !== null &&
          permissionsOf.backOffice.length > 0 && (
            <div className={`${styles['list-heading']}`}>BACK-OFFICE</div>
          )}
        <ul>
          {_.sortBy(permissionsOf.backOffice, 'priority_rank').map(
            permission => (
              <li key={permission.id}>• {permission.menu}</li>
            )
          )}
        </ul>
      </Popover>
    );

    const hasAllPrivileges = role.permissions.length === userPermissions.length;
    if (hasAllPrivileges) {
      accessGroupTypeMessage = 'App & Back-office';
      privilegesMessage = 'All Privileges';
    } else {
      if (permissionOf.app.length === 0) {
        accessGroupTypeMessage = 'Back-office Only';
      } else if (permissionOf.backOffice.length === 0) {
        accessGroupTypeMessage = 'App Only';
      } else {
        accessGroupTypeMessage = 'App & Back-office';
      }

      privilegesMessage =
        roleTotalPermission === 1
          ? `${roleTotalPermission} Privilege`
          : `${roleTotalPermission} Privileges`;
    }

    return (
      <div>
        <div style={{ width: '140px' }} className={`pull-left`}>
          {accessGroupTypeMessage}
        </div>
        <OverlayTrigger
          trigger={['hover', 'focus']}
          overlay={popoverAccess}
          placement="left"
        >
          <div
            className={`${
              hasAllPrivileges
                ? styles['all-privileges-label']
                : styles['some-privileges-label']
            } pull-left`}
          >
            {privilegesMessage}
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  _onClickRow = () => {
    const { onClickRow, role } = this.props;
    onClickRow(role);
  };
}

export default Row;
